<template>
  <a
    class="rr-link"
    :class="classes"
    :is="tagName"
    :href="!disabled && href"
    :disabled="disabled"
    :type="tagName === 'button' && 'button'"
    @click="$emit('click', $event)"
  >
    <span class="rr-link__icon" v-if="iconLeft">
      <Icon :name="iconLeft"></Icon>
    </span>
    <slot></slot>
    <span class="rr-link__text" v-if="text" v-html="text"></span>
    <span class="rr-link__icon" v-if="iconRight">
      <Icon :name="iconRight"></Icon>
    </span>
  </a>
</template>

<script>
import Icon from '@rr-component-library/icon/src/main';

export default {
  name: 'Link',
  designVersion: '1.0.0',
  components: {
    Icon,
  },
  props: {
    /**
     * Текст ссылки
     */
    text: {
      type: String,
    },
    /**
     * Внешний вид
     */
    variant: {
      type: String,
      default: 'primary',
      validator(value) {
        return ['primary', 'secondary', 'inherit'].indexOf(value) !== -1;
      },
    },
    /**
     * Размер
     */
    size: {
      type: String,
      default: '',
      validator(value) {
        return ['', 'xs', 'sm', 'md', 'lg'].indexOf(value) !== -1;
      },
    },
    /**
     * HTML-атрибут href — адрес ссылки
     */
    href: {
      type: String,
    },
    /**
     * Ссылка на маршрут vue-роутера.
     * Заменяет тег на \<router-link\>.
     */
    to: {
      type: String,
    },
    /**
     * HTML-тег
     */
    tag: {
      type: String,
    },
    /**
     * Блокировка ссылки
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Иконка слева
     */
    iconLeft: {
      type: String,
    },
    /**
     * Иконка справа
     */
    iconRight: {
      type: String,
    },
  },
  computed: {
    tagName() {
      if (this.tag) {
        return this.tag;
      }
      if (this.to) {
        return 'router-link';
      }
      return 'a';
    },
    classes() {
      const classes = {};
      [this.variant, this.size].forEach((val) => {
        if (val) {
          classes[`rr-link_${val}`] = true;
        }
      });
      return classes;
    },
  },
};
</script>

<style lang="scss">
@import "./Link";
</style>
